import _ from 'lodash';
import { Component } from '@angular/core';
import { CfsService, CfsModel, PagerService, AlertService } from '../../services/index';
import { Util } from '../../utils/util';

declare var $:any;

@Component({
  selector: 'cfs-list',
  templateUrl: 'cfs-list.html' 
})
export class CfsList {
  
  cfs: CfsModel = new CfsModel();
  allUserCfsList: Array<CfsModel> = new Array();
  userCfsList: Array<CfsModel> = new Array();
  
  allMasterCfsList: Array<CfsModel> =  new Array();
  masterCfsList: Array<CfsModel> =  new Array();

  pager: any = {};
  pagedItems: any[];

  pager2: any = {};
  pagedItems2: any[];

  selectedCfs;
  showCfsInfo:boolean = false;

  searchText: string = '';

  constructor(
    private cfsService: CfsService,
    private pagerService: PagerService,
    private alertService: AlertService,
  ) {

  }
  
  ngOnInit() {
    this.cfsService.getCfsListForAdmin().subscribe(
      resp => {
        let data = resp.data;
        this.allMasterCfsList = data.cfsListForMaster;
        this.masterCfsList = data.cfsListForMaster;
        this.userCfsList = data.cfsListForUser;
        this.allUserCfsList = data.cfsListForUser;
        this.setPage(1);          
        this.setPage2(1);
      }
    );
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.masterCfsList.length, page);

    // if (page < 1) {
    //   return;
    // }

    if(page > this.pager.totalPages) {
      this.pager = this.pagerService.getPager(this.masterCfsList.length, this.pager.totalPages);
    }

    this.pagedItems = this.masterCfsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPage2(page:number) {
    this.pager2 = this.pagerService.getPager(this.userCfsList.length, page);
    
    // if (page < 1) {
    //   return;
    // } 

    this.pagedItems2 = this.userCfsList.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
  }

  searchCfs(event) {
    var filterValue = event.target.value;
    this.masterCfsList = [];

    this.masterCfsList = _.filter(this.allMasterCfsList, item => {
			if (!filterValue) return true;

			let valuesStr = Util.getString(item);
			const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
    });
    
    this.setPage(1);
  }

  searchCfs2(event) {
    var filterValue = event.target.value;
    this.userCfsList = [];

    this.userCfsList = _.filter(this.allUserCfsList, item => {
			if (!filterValue) return true;

			let valuesStr = Util.getString(item);
			const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
    });
    
    this.setPage2(1);
  }

  editCfs(cfs) {
    this.selectedCfs = cfs;
    this.openCfsInfo();
  }

  openCfsInfo() {
    this.showCfsInfo = true;
    $('body').css('overflow', 'hidden');
  }

  closeCfsInfo() {
    this.showCfsInfo = false;
    $('body').css('overflow', 'auto');
  }

  addToMaster(cfs) {
    var findCfs = _.find(this.masterCfsList, {code: cfs.code});
    if(_.isEmpty(findCfs)) {
      this.selectedCfs = cfs;
      this.selectedCfs.corpId = null;
      this.cfsService.postCfs(this.selectedCfs).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('추가되었습니다.');
            this.masterCfsList.push(this.selectedCfs);
            this.setPage(this.pager.totalPages);
          } else {
            this.alertService.error(resp.errorMsg);
          }
        }
      );
    } else {
      this.alertService.error('이미 존재하는 CFS입니다.');
    }
  }

  addNewCfs() {
    this.selectedCfs = new CfsModel();
    this.masterCfsList.push(this.selectedCfs);
    this.setPage(this.pager.currentPage);

    this.openCfsInfo();
  }

  deleteCfs(cfs) {
    if(cfs.cfsId != null) {
      this.cfsService.delCfs(cfs.cfsId).subscribe(
        resp => {
          console.log(resp);
        }
      );
    }

    var cfsIndex = _.findIndex(this.masterCfsList, {cfsId: cfs.cfsId});
    this.masterCfsList.splice(cfsIndex, 1);
    
    this.setPage(this.pager.currentPage);
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/cfs/cfs-list.ts